import React, { useMemo, useRef, useState } from 'react';
import useItemListActions from '../../shared/cmsPage/hooks/useItemListActions';
import useArray from '../../shared/util/hooks/useArray';
import subtenantApi from '../api/subtenantApi';
import EditSubtenantModal from '../components/EditSubtenantModal';
import { SubtenantConstants } from '../definitions';

export default function useSubtenantActions(showAffiliation) {
  const { remove, requestPending } = useItemListActions(subtenantApi, SubtenantConstants, {
    excludePublishMsg: true,
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [subtenant, setSubtenant] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const reloadRef = useRef(null);
  const close = async () => {
    setModalOpen(false);
    setSubtenant(null);
    if (typeof reloadRef.current === 'function') await reloadRef.current();
  };
  const add = useMemo(
    () => ({
      label: '+ Add Subtenant',
      onClick: ({ reload }) => {
        setSubtenant(null);
        setModalOpen(true);
        setIsNew(true);
        reloadRef.current = reload;
      },
    }),
    []
  );
  const removeOverride = useMemo(
    () => ({
      ...remove,
      disabled: (item) => item.isDefault,
    }),
    [remove]
  );
  const edit = useMemo(
    () => ({
      label: 'Edit',
      onClick: async (item, { reload }) => {
        setSubtenant(item);
        setModalOpen(true);
        setIsNew(false);
        reloadRef.current = reload;
      },
      icon: 'fa-solid fa-pencil',
      disabled: (item) => item.isDefault,
    }),
    []
  );
  const SubtenantModal = (
    <EditSubtenantModal
      isNew={isNew}
      open={modalOpen}
      onClose={close}
      subtenant={subtenant}
      saveSubtenant={subtenantApi.saveRecord}
      showAffiliation={showAffiliation}
    />
  );
  const toolbarActions = useMemo(() => [add], [add]);
  const itemActions = useArray(edit, removeOverride);
  return { toolbarActions, itemActions, requestPending, SubtenantModal };
}
